import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Moon, Sun } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'
import { useTheme } from '../contexts/ThemeContext'
import Auth from './Auth'
import './Header.css'

export default function Header() {
  const { user, signOut } = useAuth()
  const { theme, toggleTheme } = useTheme()
  const [showAuth, setShowAuth] = useState(false)
  const [showMenu, setShowMenu] = useState(false)

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="logo" aria-label="Oil & Gas Conversions Home">
          <svg viewBox="0 0 48 48" width="40" height="40" aria-hidden="true">
            <circle cx="24" cy="24" r="22" fill="#0084A8" stroke="#0084A8" strokeWidth="2"/>
            <rect x="16" y="12" width="16" height="24" fill="none" stroke="#fff" strokeWidth="1.5"/>
            <rect x="18" y="14" width="2" height="2" fill="#fff"/>
            <rect x="22" y="14" width="2" height="2" fill="#fff"/>
            <rect x="26" y="14" width="2" height="2" fill="#fff"/>
            <rect x="18" y="18" width="2" height="2" fill="#fff"/>
            <rect x="22" y="18" width="2" height="2" fill="#fff"/>
            <rect x="26" y="18" width="2" height="2" fill="#fff"/>
            <rect x="18" y="22" width="2" height="2" fill="#fff"/>
            <rect x="22" y="22" width="2" height="2" fill="#fff"/>
            <rect x="26" y="22" width="2" height="2" fill="#fff"/>
            <rect x="20" y="26" width="8" height="2" fill="#fff"/>
          </svg>
        </Link>
        <h1>Oil & Gas Conversions</h1>

        <nav className="header-nav">
          <Link to="/blog" className="nav-link">Blog</Link>
          <button
            onClick={toggleTheme}
            className="theme-toggle"
            title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode - Optimized for field use`}
            style={{
              background: theme === 'light' ? '#f3f4f6' : '#FF6B35',
              border: theme === 'light' ? '2px solid #d1d5db' : '2px solid #FF6B35',
              cursor: 'pointer',
              padding: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px',
              transition: 'all 0.2s',
              boxShadow: theme === 'light' ? '0 1px 3px rgba(0, 0, 0, 0.1)' : '0 2px 4px rgba(255, 107, 53, 0.3)',
              color: theme === 'light' ? '#111827' : '#ffffff'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = theme === 'light'
                ? '0 2px 4px rgba(0, 0, 0, 0.15)'
                : '0 4px 8px rgba(255, 107, 53, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = theme === 'light'
                ? '0 1px 3px rgba(0, 0, 0, 0.1)'
                : '0 2px 4px rgba(255, 107, 53, 0.3)';
            }}
          >
            {theme === 'light' ? (
              <Moon size={22} strokeWidth={2.5} />
            ) : (
              <Sun size={22} strokeWidth={2.5} />
            )}
          </button>
        </nav>

        <div className="header-auth">
          {user ? (
            <div className="user-menu">
              <button className="user-button" onClick={() => setShowMenu(!showMenu)}>
                <div className="user-avatar">
                  {user.email?.charAt(0).toUpperCase()}
                </div>
                <span>{user.email}</span>
              </button>
              {showMenu && (
                <div className="user-dropdown">
                  <Link to="/dashboard" className="dropdown-link" onClick={() => setShowMenu(false)}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    My Dashboard
                  </Link>
                  <Link to="/subscription" className="dropdown-link" onClick={() => setShowMenu(false)}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    Subscription
                  </Link>
                  <button onClick={() => { signOut(); setShowMenu(false); }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                    </svg>
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          ) : (
            <button className="auth-button" onClick={() => setShowAuth(true)}>
              Sign In
            </button>
          )}
        </div>
      </div>

      {showAuth && <Auth onClose={() => setShowAuth(false)} />}
    </header>
  )
}
